import React from "react";
import { FaHeart, } from "react-icons/fa";
import { IoLocationOutline } from "react-icons/io5";

const AboutUs = () => {
  return (
    <div className="bg-light py-8 px-3 md:py-12 md:px-12 lg:px-24">
      {/* About Us Section */}
      <section className="max-w-5xl mx-auto text-center mb-12 md:mb-16">
        <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4 md:mb-6">
          About Us
        </h2>        <p className="text-sm md:text-lg text-gray-700 leading-relaxed">
        “Param” is a Sanskrit word which means the highest, the ultimate, the most supreme. At Param Life, we empower people to live at their highest potential — where success doesn’t cost health, ambition doesn’t make you emotionally void, and happiness isn’t an afterthought. We believe the best life isn’t about compromise — it’s about wholeness, where success, prosperity, purpose, vibrant health, fulfilling relationships, and deep inner joy co-exist.</p>
        <p className="text-sm md:text-lg text-gray-700 leading-relaxed mt-2 md:mt-4">
          Founded by Gaurv and Monika, alumni of IIT Kharagpur and IIM Lucknow, Param Life is not just a start-up but a movement to bring about a Holistic Wellness revolution. Param Life is a powerful platform for people to learn and adopt holistic wellbeing practices in an easy and practical way to excel in every aspect of life.
        </p>
        <p className="text-sm md:text-lg text-gray-700 leading-relaxed mt-2 md:mt-4">
          Having been in leadership roles at multiple corporates and realizing that conventional success alone is insufficient to offer genuine and lasting joy and fulfilment, the founders got inspired to discover the secrets of Holistic Wellbeing and found their answers in Yoga, Ayurveda, Positive Psychology, and Vedanta.Under the guidance of Swami Janardhanananda Saraswati, from the lineage of Swami Sivananda, who is a Yogi and a monk in the Himalayas in Uttarkashi, both of them learnt, studied, and practiced different practical techniques which had a great impact on their lives.     
        </p>
        <p className="text-sm md:text-lg text-gray-700 leading-relaxed mt-2 md:mt-4">
        After integrating the it in their own lives and witnessing the impact, they felt driven to build Param Life to share these insights, practices, and techniques with others who seek long-lasting health, happiness, and fulfilment. Param has conducted multiple programs, both offline and online, impacting lives of many people and aims to make this revolution a global phenomenon.
</p>
      </section>

      {/* Mission, Vision, and Goal */}
      <div className="grid gap-6 md:gap-12 max-w-5xl mx-auto">
        {[
          { title: "Our Mission", text: "To enable individuals to live healthier, happier, and more mindful lives...", image: "/assets/aboutpg/missionn.png", reverse: false },
          { title: "Our Vision", text: "To be among the most trusted and respected organizations in inspiring holistic wellness...", image: "/assets/aboutpg/vision.png", reverse: true },
          { title: "Our Goal", text: "Our goal is to positively impact the well-being of 1 million people by 2035.", image: "/assets/aboutpg/goal.png", reverse: false },
        ].map((item, index) => (
          <div key={index} className={`bg-white shadow-lg rounded-xl p-4 md:p-8 flex flex-col ${item.reverse ? "md:flex-row-reverse" : "md:flex-row"} items-center`}>
            <div className="md:w-1/2 mb-4 md:mb-0 text-center md:text-left">
              <h3 className="text-xl md:text-2xl font-semibold text-primary">{item.title}</h3>
              <p className="text-sm md:text-lg text-gray-700 mt-2 md:mt-4">{item.text}</p>
            </div>
            <div className="md:w-1/2 flex justify-center">
              <img src={item.image} alt={item.title} className="rounded-lg  w-4/5 md:w-auto max-h-40 md:max-h-64 object-cover" />
            </div>
          </div>
        ))}
      </div>

      {/* Values Section */}
      <section className="max-w-4xl mx-auto mt-12 md:mt-16">
  <h3 className="text-xl md:text-3xl font-bold text-primary text-center mb-6 md:mb-8">
    Our Values
  </h3>
  <div className="bg-white shadow-lg rounded-lg p-6 md:p-8 max-w-3xl mx-auto">
    {[
      { title: "Authenticity", description:"We practice what we preach and believe in inspiring others by our own actions." },
      { title: "Integrity", description: "We deliver what we commit and we commit what we can deliver." },
      { title: "Sincerity", description: "We give our best in what we do and strive to be our better version every day." },
      { title: "Empathy", description: "We understand, support, respect, and empower people around us." },
    ].map((value, index) => (
      <div key={index} className="flex items-center space-x-3 mb-4 last:mb-0">
        <span className="text-lg md:text-xl"><FaHeart className="text-red-500" /> 
</span>
        <p className="text-sm md:text-base text-gray-700">
          <span className="text-lg md:text-lg font-semibold text-secondary">{value.title}</span> – {value.description}
        </p>
      </div>
    ))}
  </div>
</section>

<div className="bg-accent mt-8 py-12 px-4 md:px-12 lg:px-24 text-center">
      {/* Headings */}
      <h2 className="text-3xl md:text-4xl mb-10 font-bold text-secondary ">Our Team</h2>

      {/* Team Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
        {[ 
          {
            name: "Gaurv Parmarthy",
            role: "Founder, CEO",
            education: "IIT Kharagpur, Sivananda YVC",
            image: "/assets/aboutpg/Founder.png",
            linkedin: "https://www.linkedin.com/in/gaurav-bansal-b429b63a/"
          },
          {
            name: "Monika Meena",
            role: " Chief Marketing Officer",
            education: "DU, IIM Lucknow, Sivananda YVC",
            image: "/assets/aboutpg/Cofounder.png",
            linkedin: "https://www.linkedin.com/in/monika-meena-883461b2/"
          }
        ].map((member, index) => (
          <a href={member.linkedin} key={index} className="block">
            <div className="bg-white shadow-lg hover:shadow-xl transition duration-300 rounded-2xl p-6 flex flex-col items-center">
              <img 
                src={member.image} 
                alt={member.name} 
                className="w-24 h-24  mb-4  object-cover"
              />
              <h4 className="text-xl font-semibold text-primary">{member.name}</h4>
              <p className="text-gray-600">{member.role}</p>
              <p className="text-sm text-gray-500">{member.education}</p>
            </div>
          </a>
        ))}
      </div>
<div className="mt-16 text-center">
  <h3 className="text-2xl md:text-3xl font-bold text-secondary mb-8">Visionary Advisors</h3>

  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
    {[
       {
    name: "Ajay Dwivedi",
    role: "Chief Growth Advisor",
    image: "/assets/aboutpg/ajay.png",
    linkedin: "https://www.linkedin.com/in/ajay-kumar-dwivedi-64a443106/"
  },
  {
    name: "Prateek Jain",
    role: "Chief Strategy Advisor",
    image: "/assets/aboutpg/prateek.png",
    linkedin: "https://www.linkedin.com/in/prateek-jain-kgp/"
  },
  {
    name: "Aditya Goel",
    role: "Chief Technology Advisor",
    image: "/assets/aboutpg/aditya.png",
    linkedin: "https://www.linkedin.com/in/adityagoel1/"
  },
    ].map((member, index) => (
      <a href={member.linkedin} key={index} className="block">
        <div className="bg-white border hover:shadow-md transition rounded-xl px-4 py-4 flex flex-col items-center text-sm">
          <img 
            src={member.image} 
            alt={member.name} 
            className="w-20 h-20 object-cover  mb-3"
          />
          <p className="font-semibold text-primary">{member.name}</p>
          <p className="text-gray-600">{member.role}</p>
        </div>
      </a>
    ))}
  </div>
</div><div className="w-full px-4 py-8 bg-accent">
  <h2 className="text-3xl font-bold text-center text-secondary mb-6">Passionate Patrons</h2>
  
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
    {[
      {
    name: "Malini A.",
    image: "/assets/aboutpg/malini.png",
    linkedin: "https://in.linkedin.com/in/malini-adapureddy"
  },
  {
    name: "Rohit Arora",
    image: "/assets/aboutpg/rohit.png",
    linkedin: "https://ca.linkedin.com/in/rohit-arora-987a0558"
  },
  {
    name: "Maanas Dwivedi",
    image: "/assets/aboutpg/maanas.png",
    linkedin: "https://www.linkedin.com/in/maanas-dwivedi-a5a600a/"
  },
  {
    name: "Gaurav Mehra",
    image: "/assets/aboutpg/gaurav.png",
    linkedin: "https://in.linkedin.com/in/gaurav-mehra-82221a50"
  }].map((patron, index) => (
      <a 
        key={index} 
        href={patron.linkedin} 
        target="_blank" 
        rel="noopener noreferrer"
        className="block"
      >
        <div className="bg-white border hover:shadow-md transition rounded-xl px-4 py-6 flex flex-col items-center text-center text-sm">
          <img 
            src={patron.image} 
            alt={patron.name} 
            className="w-20 h-20 object-cover  mb-3"
          />
          <p className="font-semibold text-primary">{patron.name}</p>
          <p className="text-gray-600">{patron.role}</p>
        </div>
      </a>
    ))}
  </div>
</div>

    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto bg-light md:mt-8 shadow-lg rounded-lg p-6 md:p-8">
        {/* Corporate Address */}
        <div className="flex items-start gap-2">
          <IoLocationOutline className="text-primary hover:text-gray-400 transition text-xl md:text-2xl" />
          <div className="text-left">
            <span className="block font-semibold text-secondary text-lg">Corporate Address:</span>
            <span className="block text-gray-700">
              No. 289, Arcadia Grant, <br />
              Badowala, Prem Nagar, <br />
              Dehradun, Uttarakhand - 248007
            </span>
          </div>
        </div>

        {/* Registered Address */}
        <div className="flex items-start gap-2">
          <IoLocationOutline className="text-primary hover:text-gray-400 transition text-xl md:text-2xl" />
          <div className="text-left">
            <span className="block font-semibold text-lg text-secondary">Regd. Address:</span>
            <span className="block text-gray-700">
              No. 2539, Shivpuri, <br />
              Kurwar Road, Niralanagar, <br />
              Sultanpur, Uttar Pradesh - 228001
            </span>
          </div>
        </div>
      </div>
 

    </div>
  );
};

export default AboutUs;
